
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.34 0C8.224 0 .023 8.283.023 18.5c0 10.218 8.2 18.5 18.317 18.5 10.116 0 18.317-8.282 18.317-18.5 0-10.217-8.2-18.5-18.317-18.5zm-6.046 28.608a231.652 231.652 0 00-3.91-.003c-.209.003-.271-.052-.271-.268.005-4.69.005-9.38 0-14.071 0-.195.046-.264.25-.264 1.32.009 2.642.011 3.964-.002.255-.003.287.096.287.318-.005 2.335-.002 4.67-.002 7.005 0 2.316-.003 4.632.005 6.948.005.263-.06.34-.323.337zM10.37 11.996c-1.419 0-2.597-1.184-2.602-2.617-.005-1.447 1.172-2.64 2.608-2.64 1.424.003 2.597 1.182 2.6 2.615 0 1.458-1.168 2.642-2.606 2.642zm19.104 16.31c0 .239-.065.302-.299.302a231.666 231.666 0 00-3.91 0c-.23.003-.28-.069-.28-.288.009-2.431.009-4.862 0-7.296-.002-.608-.04-1.22-.208-1.811-.313-1.091-1.086-1.648-2.217-1.587-1.547.082-2.35.855-2.546 2.442-.046.378-.07.759-.068 1.14.003 2.365-.002 4.73.006 7.096 0 .235-.057.304-.296.304a235.222 235.222 0 00-3.94 0c-.212.003-.271-.055-.271-.271.005-4.682.005-9.366 0-14.047 0-.233.076-.285.293-.285 1.245.008 2.494.011 3.739 0 .23-.003.288.074.285.293-.014.56-.006 1.119-.006 1.68.302-.342.549-.687.858-.98.95-.905 2.073-1.36 3.386-1.35.722.006 1.433.058 2.128.261 1.59.463 2.513 1.57 2.955 3.138.331 1.176.39 2.385.394 3.596.005 2.552-.009 5.109-.003 7.663z","fill":"#FEFEFE"}})])
          )
        }
      }
    